// extracted by mini-css-extract-plugin
export default {"image":"JY-z","loaded":"KY-z"};